import { action } from 'satcheljs';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';

export const onAvailableWidthBucketChanged = action(
    'onAvailableWidthBucketChanged',
    (availableWidthBucket: BrowserWidthBucket, source: LayoutChangeSource) => ({
        availableWidthBucket,
        source,
    })
);
